module.exports = __webpack_public_path__ + "media/images/lp/bg-voice-fd9c9f76425788c5f7052deac55d28b2.png";